// extracted by css-extract-rspack-plugin
export default {"iconButton":"pf1Cg"};